







import Vue from 'vue';
import {Component} from "vue-property-decorator";
import BillList from "@/components/bill/BillList.vue";
import AsiToolbar from "@/components/common/AsiToolbar.vue";
import CustomerWeeklyOverview from "@/components/home/CustomerWeeklyOverview.vue";
import CustomerUnpaidBills from "@/components/home/CustomerUnpaidBills.vue";

@Component({
	components: {CustomerUnpaidBills, CustomerWeeklyOverview, AsiToolbar, BillList}
})
export default class HomeCustomer extends Vue {

}
